import { ResponsePanelView } from '../view/ResponsePanelView';
import { templateResponsePanel } from '../view/template';
import { BaseWebComponentController, WebComponentEvent } from '../../../framework/BaseWebComponentController';
import { ResponsePanelWebComponent } from '..';
import { ResponseData } from '../types';

export class ResponsePanelController extends BaseWebComponentController {
  public component: ResponsePanelWebComponent;
  public view: ResponsePanelView;
  public viewConstructor: typeof ResponsePanelView;

  constructor(component: ResponsePanelWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: ResponsePanelView,
      viewTemplate: templateResponsePanel,
    });
  }

  async getDataForView(): Promise<any> {
    //} Promise<ResponseData> { // TODO type
    return this.dependencies.getAggregatedRecommendations(this.component.incidentId);
  }

  computeEventListeners() {
    return [
      {
        element: this.view.dom.$refreshButton,
        event: 'click',
        callback: this.refreshComponent,
      },
    ];
  }

  async refreshComponent() {
    await this.render();
  }
}
